const LS_PREFIX = 'erp4c-dg-col-order:';

export function loadColumnFieldOrder(storageKey) {
  if (!storageKey || typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(LS_PREFIX + storageKey);
    if (!raw) return null;
    const arr = JSON.parse(raw);
    return Array.isArray(arr) && arr.length ? arr : null;
  } catch {
    return null;
  }
}

export function saveColumnFieldOrder(storageKey, fields) {
  if (!storageKey || typeof window === 'undefined' || !fields?.length) return;
  try {
    localStorage.setItem(LS_PREFIX + storageKey, JSON.stringify(fields));
  } catch {
    /* quota / private mode */
  }
}

export function clearColumnFieldOrder(storageKey) {
  if (!storageKey || typeof window === 'undefined') return;
  try {
    localStorage.removeItem(LS_PREFIX + storageKey);
  } catch {
    /* ignore */
  }
}

/** Apply saved field order; unknown fields from colDefs are appended in original order. */
export function mergeColumnFieldOrder(colDefs, savedOrder) {
  if (!savedOrder?.length || !colDefs?.length) return colDefs;
  const map = new Map(colDefs.map((c) => [c.field, c]));
  const out = [];
  const seen = new Set();
  for (const f of savedOrder) {
    const c = map.get(f);
    if (c) {
      out.push(c);
      seen.add(f);
    }
  }
  for (const c of colDefs) {
    if (!seen.has(c.field)) out.push(c);
  }
  return out;
}
